import { render, staticRenderFns } from "./TaggedProjectListModal.vue?vue&type=template&id=15accb87&"
import script from "./TaggedProjectListModal.vue?vue&type=script&lang=js&"
export * from "./TaggedProjectListModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15accb87')) {
      api.createRecord('15accb87', component.options)
    } else {
      api.reload('15accb87', component.options)
    }
    module.hot.accept("./TaggedProjectListModal.vue?vue&type=template&id=15accb87&", function () {
      api.rerender('15accb87', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/portfolio/tags/TaggedProjectListModal.vue"
export default component.exports